/* unplugin-vue-components disabled */import script from "./Preview3d.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview3d.vue?vue&type=script&setup=true&lang=js"

import "./Preview3d.vue?vue&type=style&index=0&id=2deb50f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2deb50f9"]])

export default __exports__